import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, PhoneCall, Mail, MessageSquare } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl" />
          
          {/* Grid Pattern */}
          <div className="absolute inset-0 opacity-5">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" />
            </svg>
          </div>

          <div className="relative px-8 py-16 md:px-16 md:py-24">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Content */}
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                  Start a Global Trade
                  <span className="block text-teal-400">Conversation</span>
                </h2>
                <p className="text-xl text-slate-300 mb-8">
                  Whether you're looking to export Australian products or source 
                  quality goods for your market, we're here to help you succeed.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Link to="/contact">
                    <Button
                      size="lg"
                      className="bg-teal-600 hover:bg-teal-700 text-white px-8 rounded-xl shadow-lg shadow-teal-600/25"
                    >
                      Request a Quote
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                  <Link to="/contact">
                    <Button
                      size="lg"
                      variant="outline"
                      className="border-white/30 text-white hover:bg-white/10 px-8 rounded-xl"
                    >
                      Schedule a Call
                    </Button>
                  </Link>
                </div>
              </div>

              {/* Contact Options */}
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10">
                  <div className="p-3 rounded-xl bg-teal-500/20">
                    <Mail className="h-6 w-6 text-teal-400" />
                  </div>
                  <div>
                    <div className="text-sm text-slate-400 mb-1">Email Us</div>
                    <a href="mailto:info@navitonglobal.com.au" className="text-white font-medium hover:text-teal-400 transition-colors">
                      info@navitonglobal.com.au
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10">
                  <div className="p-3 rounded-xl bg-amber-500/20">
                    <PhoneCall className="h-6 w-6 text-amber-400" />
                  </div>
                  <div>
                    <div className="text-sm text-slate-400 mb-1">Call Us</div>
                    <a href="tel:+61478822581" className="text-white font-medium hover:text-amber-400 transition-colors">
                      +61 478822581
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10">
                  <div className="p-3 rounded-xl bg-emerald-500/20">
                    <MessageSquare className="h-6 w-6 text-emerald-400" />
                  </div>
                  <div>
                    <div className="text-sm text-slate-400 mb-1">Response Time</div>
                    <span className="text-white font-medium">Within 48 business hours</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
